export default "__VITE_ASSET__CVlUa37w__"